import { IStateErrorBase, IStateSuccessBase } from '@boxx/core';

export interface IMessagesStateError extends IStateErrorBase {
  after:
    | 'GET'
    | 'SET_LEAD_READ'
    | 'UPSERT_REVIEW'
    | 'DELETE_REVIEW'
    | 'REPLY_CONVERSATION_MESSAGE'
    | 'SET_READ_NOTIFICATION'
    | 'UNKNOWN';
}

export interface IMessagesStateSuccess extends IStateSuccessBase {
  after:
    | 'GET'
    | 'SET_LEAD_READ'
    | 'UPSERT_REVIEW'
    | 'DELETE_REVIEW'
    | 'REPLY_CONVERSATION_MESSAGE'
    | 'SET_READ_NOTIFICATION'
    | 'UNKNOWN';
}
